<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <a-form-model-item label="标的名称" prop="projectName">
        <a-input
          v-model="form.projectName"
          placeholder="请输入标的名称"
          disabled
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="租赁期限类型" prop="leaseTermType">
            <a-radio-group v-model="form.leaseTermType">
              <a-radio :value="1">固定</a-radio>
              <a-radio :value="2">区间</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.leaseTermType == 1">
          <a-form-model-item label="租赁期限" required>
            <a-form-model-item
              prop="leaseTerm"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input v-model="form.leaseTerm" placeholder="请输入租赁期限" />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="leaseTermUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-radio-group v-model="form.leaseTermUnit" button-style="solid">
                <a-radio-button :value="1"> 个 月 </a-radio-button>
                <a-radio-button :value="2"> 年 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.leaseTermType == 2">
          <a-form-model-item label="租赁期限区间" required>
            <a-form-model-item
              prop="leaseTermMin"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 95px)',
              }"
            >
              <a-input
                v-model="form.leaseTermMin"
                placeholder="请输入租赁期限下区间"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '40px',
                textAlign: 'center',
              }"
            >
              至
            </span>
            <a-form-model-item
              prop="leaseTermMax"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 95px)',
              }"
            >
              <a-input
                v-model="form.leaseTermMax"
                placeholder="请输入租赁期限上区间"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="listingPriceUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-radio-group v-model="form.leaseTermUnit" button-style="solid">
                <a-radio-button :value="1">个 月</a-radio-button>
                <a-radio-button :value="2">年</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租参考价类型" prop="listingPriceType">
            <a-radio-group v-model="form.listingPriceType">
              <a-radio :value="1">固定</a-radio>
              <a-radio :value="2">区间</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.listingPriceType == 1">
          <a-form-model-item label="出租参考价价格" required>
            <a-form-model-item
              prop="listingPrice"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input
                v-model="form.listingPrice"
                placeholder="请输入出租参考价价格"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="listingPriceUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-select
                v-model="form.listingPriceUnit"
                placeholder="请选择出租参考价单位"
              >
                <a-select-option :value="1">元/月</a-select-option>
                <a-select-option :value="2">元/年</a-select-option>
                <a-select-option :value="3">元/平方米/天</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.listingPriceType == 2">
          <a-form-model-item label="出租参考价区间" required>
            <a-form-model-item
              prop="listingPriceDown"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 95px)',
              }"
            >
              <a-input
                v-model="form.listingPriceDown"
                placeholder="请输入出租参考价下区间"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '40px',
                textAlign: 'center',
              }"
            >
              至
            </span>
            <a-form-model-item
              prop="listingPriceUp"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 95px)',
              }"
            >
              <a-input
                v-model="form.listingPriceUp"
                placeholder="请输入出租参考价上区间"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="listingPriceUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-select
                v-model="form.listingPriceUnit"
                placeholder="请选择出租参考价单位"
              >
                <a-select-option :value="1">元/月</a-select-option>
                <a-select-option :value="2">元/年</a-select-option>
                <a-select-option :value="3">元/平方米/天</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="租金参考价">
        <template v-slot:extra>
          <span style="color: red">
            本信息仅供参考，不构成出租方或平台对出租标的的任何要约、承诺或保证。本项目招租底价以招租公告信息为准。
          </span>
        </template>
        <a-input v-model="form.referenceRentPrice" disabled />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="计租数量(租赁面积)" prop="rentCount">
        <a-input
          v-model="form.rentCount"
          disabled
          placeholder="请输入计租数量"
          suffix="平方米"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否接受分割出租" prop="acceptSplitRent">
            <a-radio-group v-model="form.acceptSplitRent">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.acceptSplitRent == 1">
      <a-form-model-item label="分割出租说明" prop="splitRentDesc">
        <a-textarea
          placeholder="请输入分割说明"
          v-model="form.splitRentDesc"
          :rows="1"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="工程条件" prop="engineeringConditions">
        <a-checkbox-group
          v-model="form.engineeringConditions"
          style="width: 100%"
        >
          <a-row :gutter="[0, 12]">
            <a-col
              :span="3"
              v-for="item in dictionaries.engineeringConditionsList"
              :key="item.value"
            >
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="租赁类型" prop="leaseType">
        <a-checkbox-group v-model="form.leaseType" style="width: 100%">
          <a-row :gutter="[0, 12]">
            <a-col
              :span="3"
              v-for="item in dictionaries.leaseTypeList"
              :key="item.value"
            >
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="项目业态" prop="leaseUseType">
        <a-checkbox-group
          v-model="form.leaseUseType"
          style="width: 100%"
          disabled
        >
          <a-row :gutter="[0, 12]">
            <a-col
              :span="3"
              v-for="item in dictionaries.leaseUseType"
              :key="item.value"
            >
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
              <a-form-model-item
                prop="leaseUseDesc"
                v-if="
                  item.value == '16384' && (form.leaseUseType || []).includes('16384')
                "
              >
                <a-input v-model="form.leaseUseDesc" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>

    <a-col
      :span="24"
      v-if="(form.leaseUseType || []).includes('1') || (form.leaseUseType || []).includes('8')"
    >
      <a-row :gutter="24">
        <a-col :span="12" v-if="(form.leaseUseType || []).includes('1')">
          <a-form-model-item label="商业细分业态" prop="businessCategories">
            <a-tree-select
              v-model="form.businessCategories"
              :tree-data="businessCategoryTree"
              placeholder="请选择商业细分业态"
              style="width: 100%"
              tree-checkable
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              allow-clear
              tree-default-expand-all
              @focus="businessCategoryTreeDictionaries"
            >
              <a-spin
                v-if="fetching.businessCategoryTree"
                slot="notFoundContent"
                size="small"
              />
            </a-tree-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="(form.leaseUseType || []).includes('8')">
          <a-form-model-item label="园区细分业态" prop="parkCategories">
            <a-tree-select
              v-model="form.parkCategories"
              :tree-data="parkCategoryTree"
              placeholder="请选择园区细分业态"
              style="width: 100%"
              tree-checkable
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              allow-clear
              tree-default-expand-all
              @focus="parkCategoryTreeDictionaries"
            >
              <a-spin
                v-if="fetching.parkCategoryTree"
                slot="notFoundContent"
                size="small"
              />
            </a-tree-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="装修现状" prop="decorateStatus">
        <a-select v-model="form.decorateStatus" placeholder="请选择装修现状">
          <a-select-option :value="1">精装</a-select-option>
          <a-select-option :value="2">毛坯</a-select-option>
          <a-select-option :value="3">简装</a-select-option>
          <a-select-option :value="4">拎包入住</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="是否允许装修改造" prop="allowRemodeling">
        <a-radio-group v-model="form.allowRemodeling">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24" v-if="form.allowRemodeling == 1">
      <a-form-model-item label="装修改造说明" prop="remodelingDesc">
        <a-input
          v-model="form.remodelingDesc"
          placeholder="请输入装修改造说明"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="项目描述" prop="projectDesc">
        <a-textarea
          v-model="form.projectDesc"
          :placeholder="'1.对交通、商业等周边配套情况介绍\n2.对项目亮点、特征、优势等得描述\n3.项目关键词：如随时可看、随时入住、价格可议、临街等'"
          :rows="3"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="业态要求" prop="formatRequirements">
        <a-textarea
          v-model="form.formatRequirements"
          placeholder="此处可填写倾向业态或禁止业态"
          :rows="3"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否有停车位" prop="parkingSpaceAvailable">
            <a-radio-group v-model="form.parkingSpaceAvailable">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.parkingSpaceAvailable == 1">
          <a-form-model-item label="停车位个数" prop="numberParkingSpaces">
            <a-form-model-item
              prop="numberParkingSpaces"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input-number
                :min="0"
                :precision="0"
                style="width: 100%"
                v-model="form.numberParkingSpaces"
                placeholder="请输入停车位个数"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '10px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="rentTimeEnd"
              :style="{
                display: 'inline-block',
                width: '60px',
              }"
            >
              <a-radio-group default-value="a" button-style="solid">
                <a-radio-button value="a"> 个 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-form-model-item
        label="政策推介"
        prop="policyRecommendations"
        extra="注：政策介绍内容不允许有外部链接。"
      >
        <a-textarea
          v-model="form.policyRecommendations"
          placeholder="请输入政策推介"
          :rows="3"
        />
      </a-form-model-item>
    </a-col>

    <!-- 租金调整 -->
    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否涉及租金调整" prop="hasRentAdjustments">
            <a-radio-group v-model="form.hasRentAdjustments">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.hasRentAdjustments == 1">
          <a-form-model-item label="租金调整方式" prop="rentAdjustmentWay">
            <a-textarea
              placeholder="例：每 x 年递增 x % "
              v-model="form.rentAdjustmentWay"
              :rows="1"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <!-- 免租期 -->
    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否有免租期" prop="hasRentFreePeriod">
            <a-radio-group v-model="form.hasRentFreePeriod">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="2">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.hasRentFreePeriod == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="免租期类型" prop="hasRentFreePeriodType">
            <a-radio-group v-model="form.hasRentFreePeriodType">
              <a-radio :value="1">固定</a-radio>
              <a-radio :value="2">区间</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col
          :span="12"
          v-if="form.hasRentFreePeriod == 1 && form.hasRentFreePeriodType == 1"
        >
          <a-form-model-item label="免租期时间" required>
            <a-form-model-item
              prop="rentFreePeriod"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input
                v-model="form.rentFreePeriod"
                placeholder="请输入免租期时间"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="rentFreePeriodUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-select
                v-model="form.rentFreePeriodUnit"
                placeholder="请选择出租参考价单位"
              >
                <a-select-option :value="1">日</a-select-option>
                <a-select-option :value="2">个月</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col
          :span="12"
          v-if="form.hasRentFreePeriod == 1 && form.hasRentFreePeriodType == 2"
        >
          <a-form-model-item label="免租期区间" required>
            <a-form-model-item
              prop="rentFreePeriodMin"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 95px)',
              }"
            >
              <a-input
                v-model="form.rentFreePeriodMin"
                placeholder="请输入免租期时间最小"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '40px',
                textAlign: 'center',
              }"
            >
              至
            </span>
            <a-form-model-item
              prop="rentFreePeriodMax"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 95px)',
              }"
            >
              <a-input
                v-model="form.rentFreePeriodMax"
                placeholder="请输入免租期时间最大"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="rentFreePeriodUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-select
                v-model="form.rentFreePeriodUnit"
                placeholder="请选择出租参考价单位"
              >
                <a-select-option :value="1">日</a-select-option>
                <a-select-option :value="2">个月</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.hasRentFreePeriod == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="优先承租权人续租是否享有免租期"
            prop="isRfpEtLr"
          >
            <a-radio-group v-model="form.isRfpEtLr">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="租赁期限是否含免租期"
            prop="hasRentContainFreePeriod"
          >
            <a-radio-group v-model="form.hasRentContainFreePeriod">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="是否有物业管理费"
            prop="hasPropertyManagementFee"
          >
            <a-radio-group v-model="form.hasPropertyManagementFee">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.hasPropertyManagementFee == 1">
          <a-form-model-item
            label="物业管理费金额"
            prop="propertyManagementFee"
          >
            <a-form-model-item
              prop="propertyManagementFee"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input
                v-model="form.propertyManagementFee"
                placeholder="请输入物业管理费金额"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="propertyManagementFeeUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-select
                v-model="form.propertyManagementFeeUnit"
                placeholder="请选择出租参考价单位"
              >
                <a-select-option :value="1">元/天/平方米</a-select-option>
                <a-select-option :value="2">元/月/平方米</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否可转租" prop="sublease">
            <a-radio-group v-model="form.sublease">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.sublease == 1">
      <a-form-model-item label="转租说明" prop="subleaseDesc">
        <a-textarea
          v-model="form.subleaseDesc"
          :rows="1"
          placeholder="请输入转租说明"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="租金支付要求" required>
        <a-radio-group v-model="form.rentPaymenclaim" class="full-radio-group">
          <!-- 押付 -->
          <a-radio :value="1">
            <span class="radio-inline-wrap">
              <span>押</span>
              <span>
                <a-form-model-item
                  prop="rentPaymenclaimDeposit"
                  class="inline-form-item"
                >
                  <a-input-number
                    :min="0"
                    :precision="0"
                    v-model="form.rentPaymenclaimDeposit"
                    class="inline-input"
                    placeholder="请输入支付要求"
                    :disabled="form.rentPaymenclaim !== 1"
                  />
                </a-form-model-item>
              </span>
              <span>付</span>
              <span>
                <a-form-model-item
                  prop="rentPaymenclaimPay"
                  class="inline-form-item"
                >
                  <a-input-number
                    :min="0"
                    :precision="0"
                    v-model="form.rentPaymenclaimPay"
                    class="inline-input"
                    placeholder="请输入支付要求"
                    :disabled="form.rentPaymenclaim !== 1"
                  />
                </a-form-model-item>
              </span>
            </span>
          </a-radio>

          <!-- 其他 -->
          <a-radio :value="2">
            <span class="radio-inline-wrap">
              <span>其他</span>
              <span>
                <a-form-model-item
                  prop="rentPaymenclaimOtherDesc"
                  class="inline-form-item"
                >
                  <a-input
                    v-model="form.rentPaymenclaimOtherDesc"
                    class="inline-input"
                    placeholder="请输入其他租金支付要求"
                    :disabled="form.rentPaymenclaim !== 2"
                  />
                </a-form-model-item>
              </span>
            </span>
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="其他说明" prop="otherDesc">
        <a-textarea
          v-model="form.otherDesc"
          :rows="1"
          placeholder="如：租赁详细信息、房屋状态、签约要求等"
        />
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
import {
  getBusinessCategories,
  getParkCategories,
} from "@/api/shexgrp/Dictionaries.js";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      fetching: {
        businessCategoryTree: false,
        parkCategoryTree: false,
      },
      businessCategoryTree: [],
      parkCategoryTree: [],

      dictionaries: {
        engineeringConditionsList: [
          {
            value: "1",
            note: "水",
            classify: "ZLPT_GCTJ",
          },
          {
            value: "2",
            note: "电",
            classify: "ZLPT_GCTJ",
          },
          {
            value: "4",
            note: "煤",
            classify: "ZLPT_GCTJ",
          },
          {
            value: "8",
            note: "排烟",
            classify: "ZLPT_GCTJ",
          },
          {
            value: "16",
            note: "排污",
            classify: "ZLPT_GCTJ",
          },
          {
            value: "32",
            note: "电梯",
            classify: "ZLPT_GCTJ",
          },
          {
            value: "1024",
            note: "其他",
            classify: "ZLPT_GCTJ",
          },
        ],
        leaseTypeList: [
          {
            value: "1",
            note: "房屋",
            classify: "ZLPT_ZLLX",
          },
          {
            value: "2",
            note: "场地",
            classify: "ZLPT_ZLLX",
          },
        ],
        leaseUseType: [
          {
            value: "1",
            note: "商业",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "2",
            note: "楼宇办公",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "8",
            note: "园区",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "16",
            note: "仓储",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "32",
            note: "厂房",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "64",
            note: "酒店",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "256",
            note: "住宅",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "512",
            note: "公寓",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "1024",
            note: "工业",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "2048",
            note: "农用",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "4096",
            note: "市政配套",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "8192",
            note: "场地",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "16384",
            note: "其他",
            classify: "ZLPT_ZLYT",
          },
        ],
      },
    };
  },
  watch: {
    "form.listingPriceType"() {
      this.calcReferenceRentPrice();
    },
    "form.listingPrice"() {
      this.calcReferenceRentPrice();
    },
    "form.listingPriceDown"() {
      this.calcReferenceRentPrice();
    },
    "form.listingPriceUp"() {
      this.calcReferenceRentPrice();
    },
    "form.listingPriceUnit"() {
      this.calcReferenceRentPrice();
    },
  },
  mounted() {
    this.businessCategoryTreeDictionaries();
    this.parkCategoryTreeDictionaries();
  },
  methods: {
    //初始化商业细分业态树
    businessCategoryTreeDictionaries() {
      // 已加载过，直接用
      if (this.businessCategoryTree.length > 0) {
        return;
      }
      // 缓冲转圈
      this.fetching.businessCategoryTree = true;
      getBusinessCategories()
        .then((res) => {
          if (res && res.code === "200") {
            this.businessCategoryTree = this.formatTreeData(res.data || []);
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          //缓冲转圈
          this.fetching.businessCategoryTree = false;
        });
    },

    parkCategoryTreeDictionaries() {
      // 已加载过，直接用
      if (this.parkCategoryTree.length > 0) {
        return;
      }
      // 缓冲转圈
      this.fetching.parkCategoryTree = true;
      getParkCategories()
        .then((res) => {
          if (res && res.code === "200") {
            this.parkCategoryTree = this.formatTreeData(res.data || []);
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.parkCategoryTree = false;
        });
    },

    //格式化树结构
    formatTreeData(list = []) {
      if (!Array.isArray(list)) return [];

      return list.map((item) => {
        const childList = Array.isArray(item.children) ? item.children : [];

        return {
          title: item.title,
          value: item.value,
          key: item.key,
          children: childList.length
            ? this.formatTreeData(childList)
            : undefined,
        };
      });
    },

    getListingPriceUnitText(unit) {
      const map = {
        1: "元/月",
        2: "元/年",
        3: "元/平方米/天",
      };
      return map[unit] || "";
    },

    calcReferenceRentPrice() {
      const unitText = this.getListingPriceUnitText(this.form.listingPriceUnit);

      // 没单位就直接空
      if (!unitText) {
        this.form.referenceRentPrice = undefined;
        return;
      }

      // 固定
      if (this.form.listingPriceType === 1) {
        const val = this.form.listingPrice;

        if (val === "" || val === null || val === undefined) {
          this.form.referenceRentPrice = `- ${unitText}`;
          return;
        }

        this.form.referenceRentPrice = `${val}${unitText}`;
        return;
      }

      // 区间
      if (this.form.listingPriceType === 2) {
        const down = this.form.listingPriceDown;
        const up = this.form.listingPriceUp;

        // 两个都空
        if (
          (down === "" || down === null || down === undefined) &&
          (up === "" || up === null || up === undefined)
        ) {
          this.form.referenceRentPrice = `- ${unitText}`;
          return;
        }

        // 一个有一个没有
        if (
          down !== "" &&
          down !== null &&
          down !== undefined &&
          (up === "" || up === null || up === undefined)
        ) {
          this.form.referenceRentPrice = `${down} 至 -${unitText}`;
          return;
        }

        if (
          (down === "" || down === null || down === undefined) &&
          up !== "" &&
          up !== null &&
          up !== undefined
        ) {
          this.form.referenceRentPrice = `- 至 ${up}${unitText}`;
          return;
        }

        // 正常区间
        this.form.referenceRentPrice = `${down} 至 ${up}${unitText}`;
      }
    },
  },
};
</script>

<style scoped>
.full-radio-group {
  display: flex;
  width: 100%;
}

.radio-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* radio 整体改成 flex，居中对齐 */
.ant-radio-wrapper {
  display: inline-flex !important;
  align-items: center;
}

/* 包住整句话 */
.radio-inline-wrap {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

/* form-item 行内显示 */
.inline-form-item {
  display: inline-flex !important;
  align-items: center;
  margin: 0 8px !important;
}

/* 去掉 form-item 默认下边距 */
.inline-form-item .ant-form-item {
  margin-bottom: 0 !important;
}

/* 输入框统一规格 */
.inline-input {
  width: 300px;
  min-width: 100px;
  max-width: 400px;
  margin-top: 10px;
}
</style>